var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c(
      "div",
      {
        staticClass:
          "navbar-dark project-header py-2 px-1 d-flex justify-content-between",
      },
      [
        _c(
          "div",
          {
            staticClass: "gantt-title-wrapper",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function ($event) {
                return _vm.$router.back()
              },
            },
          },
          [
            _vm._m(0),
            _c(
              "span",
              { staticClass: "align-middle ticket-title__client-name pl-0" },
              [_vm._v("Logs")]
            ),
          ]
        ),
        _c("div", { staticClass: "d-flex align-items-center" }),
      ]
    ),
    _c("div", { staticClass: "card card-body" }, [
      _vm.logs.length > 0
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("div", [
              _c("table", { staticClass: "table align-items-center" }, [
                _vm._m(1),
                _c(
                  "tbody",
                  { staticClass: "list" },
                  _vm._l(_vm.logs, function (p, i) {
                    return _c("tr", { key: i }, [
                      _c("td", { staticClass: "budget" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(p.payment_date) +
                            "\n                "
                        ),
                      ]),
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("div", { staticClass: "media align-items-center" }, [
                          _c("div", { staticClass: "media-body" }, [
                            _c("span", { staticClass: "name mb-0 text-sm" }, [
                              _vm._v(_vm._s(p.name)),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("td", { staticClass: "budget" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(p.subject) +
                            "\n                "
                        ),
                      ]),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm text-white bg-danger my-2 mt-2 mb-2 ml-2 my-md-0",
                            attrs: {
                              type: "button",
                              "data-toggle": "tooltip",
                              "data-placement": "top",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onArchieveClicked(p)
                              },
                            },
                          },
                          [_vm._v("\n          Clear\n        ")]
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ])
        : _c("h4", [_vm._v("No Logs found ")]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", [
      _c("img", {
        staticClass: "icon icon-xs",
        attrs: { src: require("@/assets/img/icons/svgs/solid/left-arrow.svg") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Date/Time")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("User")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Subject")]),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n                   \n                "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }